import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const DeviceBreakdown = ({ data }) => {
  const COLORS = {
    desktop: 'var(--color-primary)',
    mobile: 'var(--color-accent)',
    tablet: 'var(--color-secondary)'
  };

  const deviceIcons = {
    desktop: 'Monitor',
    mobile: 'Smartphone',
    tablet: 'Tablet'
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-md p-3 shadow-elevation-md">
          <p className="text-sm font-medium text-popover-foreground mb-1">
            {payload?.[0]?.name}
          </p>
          <p className="text-sm text-muted-foreground">
            {payload?.[0]?.value} submissions ({payload?.[0]?.payload?.percentage}%)
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-md p-4 md:p-6 shadow-elevation-sm">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
        Device Breakdown
      </h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="w-full h-64" aria-label="Device Distribution Pie Chart">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {data?.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS?.[entry?.device]} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="space-y-3">
          {data?.map((item) => (
            <div 
              key={item?.device}
              className="flex items-center justify-between p-3 bg-muted rounded-md"
            >
              <div className="flex items-center gap-3">
                <div 
                  className="w-10 h-10 rounded-md flex items-center justify-center"
                  style={{ backgroundColor: `${COLORS?.[item?.device]}20` }}
                >
                  <Icon 
                    name={deviceIcons?.[item?.device]} 
                    size={20} 
                    color={COLORS?.[item?.device]} 
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground capitalize">
                    {item?.device}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {item?.value} submissions
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-lg font-semibold text-foreground">
                  {item?.percentage}%
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DeviceBreakdown;